import Layout from '@layout/Index'

export const companyBankAccount = [
  {
    path: '/company-bank-account',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "company-bank-account-table" */ './pages/CompanyAccountTable.vue'),
        name: '对公账户列表',
        meta: {
          title: '对公账户列表',
        },
      },
      {
        path: 'create/batch',
        component: () => import(/* webpackChunkName: "user-bank-account-batch" */ './pages/CompanyBankBatchForm.vue'),
        name: '批量添加对公账户',
        meta: {
          title: '批量添加/修改对公账户',
        },
      }
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/company-bank-account/company-bank-account.route.js